import { useEffect } from "react";
import QuizEmbed from "@/components/feature/QuizEmbed";

export default function Quiz() {
  useEffect(() => {
    const originalTitle = document.title;
    document.title = "Destination Quiz – Find Your Best Dental Country | Dental Safety Abroad";
    const metaDesc = document.querySelector('meta[name="description"]');
    const originalDesc = metaDesc?.getAttribute("content") || "";
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Take our free two-minute quiz to find out whether Hungary, Poland, Turkey or Spain is the right dental destination for you."
      );
    }
    return () => {
      document.title = originalTitle;
      if (metaDesc) metaDesc.setAttribute("content", originalDesc);
    };
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      {/* Hero Banner */}
      <section className="relative bg-accent-100/60 pt-24 md:pt-28">
        <div className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14 text-center">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-600 mb-3 block">
            Free Two-Minute Quiz
          </span>
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-tight mb-4">
            Which Dental Destination Fits You?
          </h1>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto">
            Answer six questions about your treatment, priorities, and travel flexibility. We&apos;ll match you to Hungary, Poland, Turkey, or Spain — along with the key things to consider before you book.
          </p>
        </div>
      </section>

      {/* Quiz */}
      <section className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14">
        <QuizEmbed />
      </section>
    </div>
  );
}